"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectedRoutePopup = SelectedRoutePopup;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _hooks = require("../../hooks");
var _models = require("../../models");
var _icons = require("../icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function SelectedRoutePopup(_ref) {
  let {
    theme,
    routes: {
      cyclingProfile,
      hasPublicTransportsSection,
      distances: {
        total: distance
      },
      cyclingDistance,
      duration,
      cyclingDuration,
      description
    },
    showDescription
  } = _ref;
  const {
    toDistance,
    toTime
  } = (0, _hooks.useUnits)();
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(StyledHeader, null, hasPublicTransportsSection ? /*#__PURE__*/_react.default.createElement(_icons.PublicTransportIcon, null) : cyclingProfile && _models.cyclingProfiles[cyclingProfile]?.icon, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "primary"
  }, toTime(duration))), hasPublicTransportsSection ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, toTime(cyclingDuration), "\xA0", /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "widget.routing.route_details.by_bike"
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, toDistance(cyclingDistance), "\xA0", /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "widget.routing.route_details.by_bike"
  }))) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, toDistance(distance)), showDescription && description && /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, description))));
}
const Wrapper = _styledComponents.default.div``;
const StyledHeader = _styledComponents.default.div`
  align-items: center;
  display: flex;

  svg {
    margin-right: 4px;
  }
`;